export default __webpack_public_path__ + "static/media/stripe-logo.3ad553b5.svg";